
import { computed, defineComponent, onMounted, reactive, Ref, ref } from 'vue'
import { ethers, providers } from 'ethers'
import { RedPacketContract } from '@/contract/func/redPacket'
import Layout from './Layout.vue'
import BgSlot from '@/components/BgSlot.vue'
import CreateRedPack from '@/components/CreateRedPack.vue'
import TxLoading from '@/components/txLoading.vue'
import { connectWallet, getChainId, getProvider } from '@/composables/metamask'
// import Share from '@/components/Home/Share.vue'
import Success from '@/components/Home/Success.vue'
import ErrC from '@/components/Home/Err.vue'
import { getTokenInfo } from '@/composables/fxwallet'

import Load from '@/components/common/Load.vue'

import BN from 'bignumber.js'
import WalletList from '@/components/WalletList/WalletList.vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

export default defineComponent({
  components: {
    // Layout,
    // BgSlot,
    CreateRedPack,
    TxLoading,
    // Share,
    Success,
    // Load,
    ErrC
    // WalletList
  },
  setup () {
    const store = useStore()

    const router = useRouter()

    const loading = ref(false)

    const sendLoading = ref(false)

    const createStep = ref<'create' | 'success' | 'err'>('create')

    const redPackId = ref('')

    const pageReady = ref(true)

    const tokenInfoInit = reactive({
      chainType: 0,
      contract: process.env.VUE_APP_COIN_ADDRESS,
      decimals: 18,
      originalSymbol: 'PURSE',
      symbol: 'PURSE',
      logo: ''
    })

    const chainIdInit = ref()

    const redPackContractAddrInit = ref('')

    const addressInit = ref('')

    const balanceInit = ref('')

    // const totalQuantityVal = ref('0')

    const butQuantityVal = ref(0)

    let redPackContract: RedPacketContract

    async function nftBuyHandler (redPackData: {
      quantity: number;
    }) {
      console.log('nftBuyHandler', redPackContract, redPackData, tokenInfoInit.decimals, redPackData.quantity)

      if (!window.provider) return

      try {
        sendLoading.value = true

        butQuantityVal.value = redPackData.quantity

        const _hash = await redPackContract.createRedPack(redPackData, tokenInfoInit.decimals, redPackData.quantity)

        loading.value = true

        const txStatus = await window.provider.waitForTransaction(
          _hash.hash
        )

        console.log('txStatus.status', txStatus.status)

        if (txStatus.status === 1) {
          createStep.value = 'success'

          router.push({ name: 'list' })
        } else {
          createStep.value = 'err'
        }

        loading.value = false
      } catch (err) {
        // createStep.value = 'err'
        // loading.value = false
        console.log('nftBuyHandler', err)
      }

      sendLoading.value = false
    }

    const userInfo = computed(() => store.state.userInfo)

    const maxButQuantity = computed(() => {
      return new BN(userInfo.value.balance).div(new BN(10).exponentiatedBy(18)).div(process.env.VUE_APP_QUANTITY as any).toNumber()
    })

    async function connectHandler (func?: () => void) {
      console.log('------> connectHandler <------')

      if (!window.provider) return

      console.log(userInfo)

      // const _QUANTITY = process.env.VUE_APP_QUANTITY as any

      // maxButQuantity.value = new BN(userInfo.value.balance).div(new BN(10).exponentiatedBy(18)).div(_QUANTITY).toNumber()

      console.log('onMounted', userInfo.value.balance, balanceInit.value)

      redPackContract = new RedPacketContract(
        window.provider,
        userInfo.value.redPackContractAddr
      )

      // const totalQuantity = await redPackContract.totalQuantity()

      // totalQuantityVal.value = totalQuantity.toString()

      redPackContractAddrInit.value = userInfo.value.redPackContractAddr
      addressInit.value = userInfo.value.address
      chainIdInit.value = userInfo.value.chainId
      balanceInit.value = userInfo.value.balance

      func && await func()
    }

    function retryHandler () {
      createStep.value = 'create'
    }

    onMounted(() => {
      connectHandler()
    })

    return {
      loading,
      addressInit,
      chainIdInit,
      redPackContractAddrInit,
      // createRedPackHandler,
      nftBuyHandler,
      createStep,
      tokenInfoInit,
      redPackId,
      sendLoading,
      balanceInit,
      pageReady,
      maxButQuantity,
      // totalQuantityVal,
      butQuantityVal,
      connectHandler,
      retryHandler
      // provider
    }
  }
})
